<template>
    <div style="width:100%;height:100%;position: fixed;z-index:99" class="bg">
        <div class="container" v-if="!loadEnd">
            <div class="text">
                <Loading :width="widthLoad"></Loading>
                {{'三维场景加载中... '}}
            </div>
            <div class="exit" @click="$router.push('/Home/Overview/SubstationManagement')">退出三维看板</div>
        </div>
        <iframe :src="url" frameborder="0" ref="iframeDom" width="100%" height="100%" allowfullscreen="true"></iframe>
        <!-- <iframe src="http://192.168.33.198:8080" ref="iframeDom" frameborder="0" width="100%" height="100%" allowfullscreen="true"></iframe> -->
    </div>
</template>
<script>
import Loading from './Loading'
export default ({
    data() {
        return {
            url: '',
            loadEnd: false,
            width: 0,
            timer: null,
        }
    },
    props: {
        id:Number
    },
    components: {
        Loading,
    },
    computed:{
        widthLoad(){
            let width = this.width < 100 ? this.width : 100
            return width
        }
    },
    watch:{
        widthLoad(width){
            let that = this
            if(width == 100){
                that.loadEnd = true
                this.timer = setTimeout(()=>{
                        that.iframeWin.postMessage({
                            cmd: "3Dstart",
                        },"*");
                    },1000)
            }
        }
    },
    mounted() {
        this.iframeWin = this.$refs.iframeDom.contentWindow;
        window.addEventListener("message", this.handleMessage);
        this.getUrl()
    },
    beforeDestroy() {
        window.removeEventListener("message", this.handleMessage);
        this.timer && clearTimeout(this.timer)
        this.timer && (this.timer = null)
    },
    methods:{
        getUrl(){
            this.url = this.$store.getters.getWebUrl
        },
        handleMessage(event) {
            const data = event.data;
            switch (data.cmd) {
                case "exit":
                    this.$router.push('/Home/Overview/SubstationManagement')
                    break
                case "loadEnd":
                    this.width = 100
                    break
                case "loadProgress":
                    console.log('加载三维切片 ');
                    this.width = data.value * 4
                    console.log(data.value );
                    break
            }
        }
    }
})
</script>
<style lang="less" scoped>
    .bg {
        width: 100vw;
        height: 100vh;
        background: #000;
        position: fixed;
        top: 0;
        left: 0;
    }

    .container {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background-image: url('../../assets/img/threebj.png');
        background-size: 100% 100%;
        color: white;

        .text {
            position: fixed;
            top: 85%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: -1;
            font-size: 30rem;
            text-shadow: 0 0 20px #0D94FF , 0 0 20px #0D94FF , 0 0 20px #0D94FF ,;
            width: 40vw;
            height: 15vh;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }

        .exit {
            position: fixed;
            right: 80px;
            top: 50px;
            font-size: 30rem;
            cursor: pointer;
        }
    }
</style>